<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mt-3"
          block
          color="green"
          style="color: white"
          v-bind="attrs"
          v-on="on"
          @click="gerarFile"
        >
          <v-icon>mdi-file</v-icon> Gerar Arquivo(.txt)
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Pré-visualização do Arquivo</span>
        </v-card-title>

        <v-card-text
          style="
            font-size: 12px;
            max-height: 300px;
            overflow: auto;
            background-color: #f9f9f9;
            font-family: monospace;
            display: flex;
          "
        >
          <div
            style="
              text-align: right;
              padding-right: 10px;
              user-select: none;
              color: #888;
              border-right: 1px solid #ccc;
              padding-top: 4px;
            "
          >
            <div v-for="(line, index) in linhas" :key="index">
              {{ index + 1 }}
            </div>
          </div>
          <div style="padding-left: 10px; white-space: pre">
            {{ txt }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="copiarTexto">
            <v-icon left>mdi-content-copy</v-icon> Copiar
          </v-btn>

          <v-btn color="orange darken-1" text @click="baixarArquivo">
            <v-icon left>mdi-download</v-icon> Baixar .txt
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      txt: `Linha 1\nLinha 2\nLinha 3\nLinha 4`,
      dialog: false,
    };
  },
  computed: {
    linhas() {
      return this.txt.split("\n");
    },
  },
  methods: {
    async gerarFile() {
      this.$loaderService.open("Carregando dados...");
      this.txt = await this.$services.censoService.gerarFile();
      this.$loaderService.close();
    },
    // copiarTexto() {
    //   if (this.txt && this.$toast) {
    //     navigator.clipboard.writeText(this.txt);
    //     this.$toast.success("Conteúdo copiado!");
    //   }
    // },
    // baixarArquivo() {
    //   if (!this.txt) return;

    //   const blob = new Blob([this.txt], { type: "text/plain" });
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.download = "arquivo.txt";
    //   link.click();
    //   URL.revokeObjectURL(url);
    // },
    copiarTexto() {
      navigator.clipboard.writeText(this.txt);
    },
    baixarArquivo() {
      const blob = new Blob([this.txt], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "arquivo.txt";
      link.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>
